module.exports = __webpack_public_path__ + "static/media/pot.7317c540.svg";